
import React, {Component} from 'react';
import {Box} from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome';
import { Popover, OverlayTrigger, ButtonToolbar, Button, Form, FormGroup, ControlLabel } from 'react-bootstrap';
import Select from 'react-select';
import Moment from 'moment';

class ReportEmployeeAdvanceSalaryRecord extends Component {
  
  constructor(...args){
    super(...args)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    const all_day = Moment().daysInMonth()

    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = "ทั้งเดือน"
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }
    
    const optionsMonth = [
      { value: 0, label: 'ทั้งปี' },
      { value: 1, label: 'มกราคม' },
      { value: 2, label: 'กุมภาพันธ์' },
      { value: 3, label: 'มีนาคม' },
      { value: 4, label: 'เมษายน' },
      { value: 5, label: 'พฤษภาคม' },
      { value: 6, label: 'มิถุนายน' },
      { value: 7, label: 'กรกฎาคม' },
      { value: 8, label: 'สิงหาคม' },
      { value: 9, label: 'กันยายน' },
      { value: 10, label: 'ตุลาคม' },
      { value: 11, label: 'พฤศจิกายน' },
      { value: 12, label: 'ธันวาคม' }
    ];

    this.state = {
      loading:false,
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultYear: yTh,
      defaultMonth: curMonth,
      defaultDay: curDay,
      data: [],
      emStatus: ''
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    const optionsDay = []

    if (all_day) {
      for (var i=0;i<=all_day;i++) {
        if (i == 0) {
          var label = "ทั้งเดือน"
        } else {
          var label = i
        }
        optionsDay.push({
          value: i,
          label: label
        })
      }
      if (all_day<this.state.defaultDay) {
        var defaultDay = 0
      } else {
        var defaultDay = this.state.defaultDay
      }
    } else {
      optionsDay.push({
        value: 0,
        label: "ทั้งเดือน"
      })
      var defaultDay = 0
    }

    this.setState({ optionsDay: optionsDay, defaultDay:defaultDay })
    return defaultDay
  }

  onYearChange(e) {
    var year = e.value - 543

    var date = year+"-"+this.state.defaultMonth
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultYear: e.value, activePage:1, defaultDay:curDay })
  }

  onMonthChange(e) {
    var date = this.state.defaultYear - 543+"-"+e.value
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({ defaultMonth: e.value, activePage:1, defaultDay:curDay })
  }

  onDayChange(e) {
    this.setState({ defaultDay: e.value })
  }

  renderTable() {
    return (
      <table className='table table-responsive table-hover table-bordered-solid table-tool'>
        <thead>
          <tr>
            <th className='text-center' style={{ width: '120px' }}>รหัสพนักงาน</th>
            <th className='text-center' style={{ width: '150px' }}>ชื่อ-นามสกุล</th>
            <th className='text-center' style={{ width: '100px' }}>ชื่อเล่น</th>
            <th className='text-center' style={{ width: '130px' }}>ตำแหน่ง</th>
            <th className='text-center' style={{ width: '100px' }}>เงินเดือน</th>
            <th className='text-center' style={{ width: '100px' }}>เงินเบิก</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  renderRowData() {
    let {data} = this.state
    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    } else {
      return('')
    }
  }

  onSaveClick() {

  }

  onCloseClick() {

  }

  onEmStatusChange(e) {
    // this.loadEmployee(e.value)

    this.setState({ emStatus: e.value })
  }

  getEmStatusOptions() {
    return ([{ value: '', label: '--- ทั้งหมดในระบบ ---' },
    { value: 'work', label: 'ทำงานอยู่ทั้งหมด' },
    { value: '0', label: 'พนักงานประจำ' },
    { value: '1', label: 'พนักงานชั่วคราว(รายเดือน)' },
    { value: '2', label: 'พนักงานชั่วคราว(รายวัน)' },
    { value: '7', label: 'ฝึกงาน' },
    { value: '8', label: 'ช่างเหมา' },
    { value: '3', label: 'ลาออก' },
    { value: '4', label: 'ไม่ผ่านเกณฑ์การเป็นพนักงาน' },
    { value: '5', label: 'หายตัวไป ติดต่อไม่ได้' },
    { value: '6', label: 'เสียชีวิต' }
    ])
  }

  render(){
    let {loading,emStatus} = this.state
    return (
      <div>
        <Box loading={loading}>
          <Box.Header>
            รายการเงินเดือนพนักงาน
          </Box.Header>
          <Box.Body>
            <Form inline>
              <FormGroup>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={ this.state.defaultYear }
                  options={this.state.optionsYear}
                  style={{ width: "150px" }}
                  onChange={ this.onYearChange.bind(this) }
                />
              </FormGroup>  
              {' '}
              <FormGroup>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={ this.state.defaultMonth }
                  options={this.state.optionsMonth}
                  style={{ width: "180px" }}
                  onChange={ this.onMonthChange.bind(this) }
                />
              </FormGroup>  
              {' '}
              <FormGroup style={{marginRight: '15px'}}>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={ this.state.defaultDay }
                  style={{ width: "100px" }}
                  options={this.state.optionsDay}
                  onChange={this.onDayChange.bind(this)}
                />
              </FormGroup>
              {' '}
              <FormGroup style={{ marginRight: '15px' }}>
                <ControlLabel> เลือกสถานะ</ControlLabel>
              </FormGroup>
              <FormGroup style={{ width: '250px' }}>
                <Select
                  value={emStatus}
                  options={this.getEmStatusOptions()}
                  clearable={false}
                  onChange={this.onEmStatusChange.bind(this)} 
                />
              </FormGroup>
            </Form>  
            <br/>
            {this.renderTable()}
          </Box.Body>
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
              <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
            </ButtonToolbar>
          </Box.Footer>
        </Box> 
      </div>   
    )
  }
}


export default ReportEmployeeAdvanceSalaryRecord;





// WEBPACK FOOTER //
// ./src/view/hr/report/ReportEmployeeAdvanceSalaryRecord.js